import { ModosOp} from "../../isp._comun/iu/_principal/constantesIuPrin";
import { TipoDeAsociado, TipoDeDoc, Sexo } from "../../isp.žapi.asociados/constantesApiAsociados";

//Si no hay input para el Dialogo de Asociado a Facturar
const getEstadoInicial = () => {
    return {
        domain: {
            screen:{
                idAsociado: "-------",
                fechaReg: "--/--/--",
                estado: "-------",

                codigoAsociado: "",
                tipoDoc: TipoDeDoc.DNI,
                nroDoc: "",
                nombres: "",
                apellidos: "",
                sexo: Sexo.SinDef,

                general: {
                    telcel1: "",
                    telcel2: "",
                    telfijo: "",
                    email: "",
                    sitioWeb: "",
                },
            },
            cargado: {}, //Data de una entidad cargada en el dialogo desde la Base de Datos
            update: {}, //Solo tiene data temporal del dominio va a modificar una entidad
            nroUpdates: 0,
        },

        error: {
            nroDocBlanc: false,
            nroDocMF: false,
            nomBlanc: false,
            nomMF: false,
            apellBlanc: false,
            apellMF: false,
            sexoBlanc: false,
            rsocialBlanc: false,
            rsocialMF: false,
            rucBlanc: false,
            rucMF: false,
            telcel1Blanc: false,
            telcel1MF: false,
            telcel2MF: false,
            telfijoMF: false,
            emailMF: false,
            sitioWebMF: false,
        },
        flag: {
            modoOperacion: ModosOp.CREAR,
            procesandoComando: false,
            modal: false,
            cargandoEntidad: false,
            // iniciando: true
            // sensorDeAccionGuardar: false,
            // sensorDeAccionActualizar: false,
        },
        personasContacto: {
            contactosOrig: [],
            contactosAct: [],
            valorListaNombres: { nombre: "Definir Nuevo" },
            listaNombres: [{ nombre: "Definir Nuevo" }],
            atributos: {
                nombre: "Definir Nuevo",
                rol: "",
                telcel1: "",
                telcel2: "",
                telfijo: "",
                email: "",
            },
            flagControNombreSelected: false,
        },
        /* update: {
            codigoAsociado: false,
            tipoAsociado: false,
            tipoDoc: false,
            nroDoc: false,
            nombres: false,
            apellidos: false,
            sexo: false,
            razonSocial: false,
            ruc: false,

            general: {
                telcel1: false,
                telcel2: false,
                telfijo: false,
                email: false,
                sitioWeb: false,
            },

        }, */
    };
};

const Registrado = {
    /* codigoAsociado: "",
    tipoAsociado: "",
    tipoDoc: "",
    nroDoc: "",
    nombres: "",
    apellidos: "",
    sexo: "",
    razonSocial: "",
    ruc: "",

    general: {
        telcel1: "",
        telcel2: "",
        telfijo: "",
        email: "",
        sitioWeb: "",
    },

    cobranza: {
        modoCobro: "asociado",
        tipoComprobante: "bol",
        cicloFact: "udiam",
    },

    personasContacto: {
        contactosOrig: [],
        contactosAct: [],
    }, */
};

export default getEstadoInicial;
